import { useEffect, useState } from "react"
import { Button, Flex } from "antd";
import { MHQPushSDK, NotificationState } from "../../services/MHQPushSDK";
import useLocalStorage from "../../hooks/useLocalStorage";

const getRandomBytes = (size: number): Uint8Array => {
    const globalCrypto = typeof crypto !== "undefined" ? crypto : undefined;
    if (globalCrypto && typeof globalCrypto.randomUUID === "function") {
        // randomUUID exists, but we still use getRandomValues for byte access
    }
    if (globalCrypto && typeof globalCrypto.getRandomValues === "function") {
        const bytes = new Uint8Array(size);
        globalCrypto.getRandomValues(bytes);
        return bytes;
    }
    if (globalCrypto && typeof (globalCrypto as any).randomFillSync === "function") {
        const bytes = new Uint8Array(size);
        (globalCrypto as any).randomFillSync(bytes);
        return bytes;
    }
    return Uint8Array.from({ length: size }, () => Math.floor(Math.random() * 256));
};

const generateUuid = (): string => {
    const bytes = getRandomBytes(16);
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes)
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

const DEFAULT_DEVICE_ID = `web_${generateUuid()}`;

export const RecieverApp = (props:{applicationId:string, apiKey:string} )=>{

    const APP_VERSION_CODE: string = `000001002000`
    const PLT: string = "web";

    const [deviceId, setDeviceId] = useLocalStorage("deviceId", DEFAULT_DEVICE_ID,{ syncData: true})
    const [sdk, setSDK] = useState<MHQPushSDK>(MHQPushSDK.create(APP_VERSION_CODE, deviceId, PLT, props.apiKey, props.applicationId))
    const [pushState, setPushState] = useState<NotificationState>(sdk.getNotificationState())
    
    useEffect(()=>{
        let newSDK = MHQPushSDK.create(APP_VERSION_CODE, deviceId, PLT, props.apiKey, props.applicationId);
        setSDK(newSDK);
        newSDK?.requestPushNotifications().then(x=>setPushState(x))

    }, [props.applicationId, props.apiKey]);

    return (
        <Flex vertical={true} align="center" gap={5}>
            <Button onClick={()=>sdk?.requestPushNotifications().then(x=>setPushState(x))}>Register for Push Notifications</Button>
            <Button onClick={()=>sdk?.unregister().then(x=>setPushState(sdk.getNotificationState()))}>Unregister for Push Notifications</Button>
            {pushState.toString()}
        </Flex>
    )
}